import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updatePatientData } from "~/patients/api/services/settingsService";

export const useUpdateUserDetails = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePatientData,
    onError: () =>
      toast.error(
        "There was an issue updating your data. Please try again later.",
      ),
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: ["getCurrentPatient"] })
        .catch(() => {
          toast.error("Failed to refresh patient data.");
        });
      toast.success("Patient updated successfully");
    },
  });
};
